import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";

import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {RockBottomGameMode} from "./server/RockBottomGameMode";
import {IRockBottomGameData} from "./server/data/IRockBottomData";
import {RockBottomGameAssets} from "./RockBottomGameAssets";
import {RockBottom} from "./RockBottom";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {RockBottomSound} from "./sound/RockBottomSound";


export class RockBottomPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "RockBottom",
            hasActionSpin: true,
            maxWin: {
                shouldPlayMaxWinInGame:(response: any) => {
                    return response.softWinCapTriggered;
                },
                playMaxWinInGame: (response: any) => {
                    return new Promise<any>((resolve, reject) => {
                        //reset reels,
                        RockBottom.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
                        RockBottom.model.data = response;
                        RockBottom.keypadPlugin.setWin(0);
                        //RestoreUtils.restoreDoubleOrNothing();

                        (<any>RockBottom.gameFlowController)._currentPresentationController.skip();

                        setTimeout(()=>{
                            RockBottom.gameFlowController.start()
                        }, 300);

                        RockBottom.apiPlugin.slotStates.stateIsReady().then(()=>{
                            resolve("")
                        });
                    });
                }
            },
            graphics: {backgroundTextureName: RockBottomGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: IRockBottomGameData, bet: number, prevResponse: IRockBottomGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank || response.softWinCapTriggered
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            RockBottom.sound.playEffect(RockBottomSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            RockBottom.sound.playEffect(RockBottomSound.AS_WIN_BIG);
        }
    }

    private isBigWin(response: IRockBottomGameData): boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice();
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: IRockBottomGameData, bet: number, prevData: IRockBottomGameData): number {
        return response.totalSpinWinnings;
    }



    private lastFeature:string = "";
    private getFeatureName(response: IRockBottomGameData): string {
        if (response.nextMode == RockBottomGameMode.FREESPIN || response.mode == RockBottomGameMode.FREESPIN) {
            this.lastFeature = "HEADSHRINKER SPINS";
            return "HEADSHRINKER SPINS";
        }

        if (response.nextMode == RockBottomGameMode.SUPER_FREESPIN || response.mode == RockBottomGameMode.SUPER_FREESPIN) {
            this.lastFeature = "INSANITY SPINS";
            return "INSANITY SPINS";
        }

        if (response.mode == RockBottomGameMode.WINCAP_PICK && response.nextMode == RockBottomGameMode.NORMAL){
            return this.lastFeature;
        }

        this.lastFeature = "";
        return "";
    }

    private isFreeSpinTriggered(response: IRockBottomGameData): boolean {
        return response.freespinTriggeredThisSpin ? response.freespinTriggeredThisSpin : false;
    }

    private isRoundComplete(response: IRockBottomGameData): boolean {
        return response.nextMode != RockBottomGameMode.WINCAP_PICK;
    }

    private isBonusEnd(response: IRockBottomGameData): boolean {
        return (response.mode === RockBottomGameMode.FREESPIN || response.mode === RockBottomGameMode.SUPER_FREESPIN) && response.nextMode === RockBottomGameMode.NORMAL;
    }

}